import { AREA_INFO } from '@briary/shared'
import { useAuth } from '../../lib/auth'
import { Card, PageHeader } from '../../ui'
import { ChangePassword, Sessions, TwoStep } from './sections'
import { SignaturePreview } from '../../modules/money/email-templates'

export default function Account() {
  const { me } = useAuth()
  if (!me) return null
  return (
    <div className="page page-narrow">
      <PageHeader title="Account & security" kicker="Your account" description={`${me.name || me.email} · ${me.email}`} />
      <div className="stack">
        <Card title="Your access">
          <dl className="kv">
            <dt>Areas</dt>
            <dd>{me.areas.map((a) => AREA_INFO[a].label).join(', ') || 'None yet'}</dd>
            {me.organisations.length > 0 && (
              <>
                <dt>Companies</dt>
                <dd>{[...new Set(me.organisations.map((o) => o.name))].join(', ')}</dd>
              </>
            )}
          </dl>
        </Card>
        {me.areas.includes('admin') && (
          <Card title="Email signature">
            <SignaturePreview />
          </Card>
        )}
        <Card title="Two-step verification">
          <TwoStep />
        </Card>
        <Card title="Password">
          <ChangePassword />
        </Card>
        <Sessions />
      </div>
    </div>
  )
}
